<template>
  <div id="app">
    <OrganismsCommonHeader />
    <router-view />
    <OrganismsPopupModal />
    <OrganismsCommonZoomImage />
    <OrganismsCommonFooter />
  </div>
</template>

<script>
import OrganismsCommonHeader from "@/components/organisms/common/Header.vue";
import OrganismsCommonFooter from "@/components/organisms/common/Footer.vue";
import OrganismsCommonZoomImage from "@/components/organisms/common/ZoomImage.vue";
import OrganismsPopupModal from "@/components/organisms/common/PopupModal.vue";

export default {
  name: "App",
  components: {
    OrganismsCommonHeader,
    OrganismsCommonFooter,
    OrganismsCommonZoomImage,
    OrganismsPopupModal 
  },
  mounted() {
    this.setMeta(this.$route);
  },
  methods:{
    setMeta(){
      document.title = "【Prestige Gold】大人が楽しむ　厳選体験生活";
    }
  }
}
</script>

<style lang="scss">
@import "@/assets/css/common.scss";
@import "@/assets/css/common/common.scss";
</style>